<template>
  <div style="display: flex; justify-content: center; flex-direction: column">
    <QuestionTimerDisplay v-if="questionTimeLeft!==null" :show="questionTimeLeft!==null" :seconds-left="questionTimeLeft"></QuestionTimerDisplay>
    <SectionButton v-if="measuresection" :show="!measureSectionDisplay" @click="sectionSidebarOpen=!sectionSidebarOpen"></SectionButton>
    <MeasureSectionSidebar v-if="measuresection" :measuresection="measuresection" v-model="sectionSidebarOpen"></MeasureSectionSidebar>
    <transition :name="transitionName" mode="out-in">
      <QuestionRenderer
          :journey-response="journeyResponse"
          :index="currentQuestionIndex"
          v-if="!!journeyResponse"
          @complete="emitComplete($event)"
          :show-instructions="measureSectionDisplay"
          @instructionsDismissed="measureSectionDisplay=false"
      ></QuestionRenderer>
    </transition>
  </div>
</template>

<script>
import QuestionRenderer from "./question/QuestionRenderer";
import MeasureSectionSidebar from "./question/section/MeasureSectionSidebar";
import SectionButton from "./question/section/SectionButton";
import applicationEventHub from "../../events/applicationEventHub";
import QuestionTimerDisplay from "./question/section/QuestionTimerDisplay.vue";
export default {
  props: {
    journeyplan: {Object: true}
  },
  name: "InternalMeasureRenderer",
  components: {
    QuestionTimerDisplay,
    QuestionRenderer,
    MeasureSectionSidebar,
    SectionButton,

  },
  computed: {
    currentQuestionIndex() {
      return this.$store.state.assessment.currentQuestionIndex;
    }
  },
  watch: {
    currentQuestionIndex(val, oldVal) {
      (!oldVal || val > oldVal) && this.setJourneyResponse(true);//Next page
      (val < oldVal) && this.setJourneyResponse(false);//Previous page
    }
  },
  data() {
    return {
      transitionName: null,
      journeyResponse: null,
      measuresection : null,
      measureSectionDisplay:false,
      sectionSidebarOpen : false,
      questionTimeLeft:null
    }
  },
  created(){

  },
  methods: {
    emitComplete(data) {
      this.$emit('complete', data);
    },
    setJourneyResponse(directionNext, delay = true) {
      if(this.$vuetify.rtl){
        this.transitionName = directionNext ? 'page-right' : 'page-left';
      }else{
        this.transitionName = directionNext ? 'page-left' : 'page-right';
      }
      this.$nextTick(() => {
        if(delay) {
          this.journeyResponse = null
        }
        setTimeout(() => {
          this.initJourneyResponse(directionNext);
        }, delay ? 300 : 0);
      });
    },
    initJourneyResponse(directionNext){
      this.journeyResponse = this.journeyplan.journeyresponses[this.currentQuestionIndex];
      this.setMeasuresection(directionNext);
    },
    setMeasuresection(directionNext){
      if(!this.journeyResponse){
        this.measuresection=null;
        this.measureSectionDisplay=false;
        return;
      }
      const question=this.journeyResponse.questionresponse.question;
      if(!question.measuresection){
        this.measuresection=null;
        this.measureSectionDisplay=false;
      }else if(question.measuresection.content && ((!this.measuresection) || (question.measuresection.measuresectionid!==this.measuresection.measuresectionid))){
        this.measuresection=question.measuresection;
        if(!this.hasDisplayedMeasuresectionIntroBefore(this.measuresection.measuresectionid)){
          this.measureSectionDisplay=directionNext;
        }
      }else{
        this.measureSectionDisplay=false;
      }
    },
    hasDisplayedMeasuresectionIntroBefore(measuresectionid){
      return this.$store.state.assessment.sectionIntrosDisplayed[measuresectionid];
    },
    showQuestionTimer(timeInSeconds) {
      this.questionTimeLeft = timeInSeconds;
    },
    hideQuestionTimer() {
      this.questionTimeLeft = null;
    }
  },
  mounted() {
    this.setJourneyResponse(true, false);
    this.$nextTick(()=>{
      applicationEventHub.frameworkNavigationDisplay(true);
    });
    applicationEventHub.$on('framework.question.timer.show',this.showQuestionTimer);
    applicationEventHub.$on('framework.question.timer.hide', this.hideQuestionTimer);
  },
  beforeDestroy() {
    applicationEventHub.frameworkNavigationDisplay(false);
    applicationEventHub.hideQuestionTimer();
    this.$nextTick(()=>{
      applicationEventHub.$off('framework.question.timer.show',this.showQuestionTimer);
      applicationEventHub.$off('framework.question.timer.hide', this.hideQuestionTimer);
    });

  }
}
</script>

<style scoped>

</style>